import { Route } from 'utils/paths';

const endpoints = {
  AUTHORIZATION: new Route('/oauth2/authorization'),
  EXCHANGE_TOKEN: new Route('/oauth2/token'),
} as const;

export default endpoints;
